<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable no-undef -->
<script setup>
  // Import components
  import { ref, computed } from 'vue';
  import { useRoute } from 'vue-router';
  import DefaultHeader from './Header.vue'
  import DefaultSidebar from './Sidebar.vue'
  import DefaultTitle from './Title.vue'
  import DomainShell from './DomainShell.vue'
  import LoadingAnimation3 from '@/components/loadingIcons/LoadingAnimation3.vue'
  import BugReportFAB from '@/components/common/BugReportFAB.vue'
  import BugReportModal from '@/components/modals/BugReportModal.vue'

  // Definitions
  defineOptions({
    name: 'DefaultLayout'
  })

  const emit = defineEmits(['update:deviceDetails']);

  defineProps({
    dataID: String,
    title: String
  })

  // References
  const pageLoading = ref(true);
  const sidebarRef = ref(null);
  const route = useRoute();
  const usesDomainShell = computed(() => route.path.startsWith('/v2/'));

  // Methods
  const handleMobileMenuToggle = () => {
    if (sidebarRef.value) {
      sidebarRef.value.toggleMobileMenu();
    }
  }
</script>

<template>
  <div class="h-screen w-screen max-w-full flex flex-col overflow-hidden bg-mesh-surface-page">
    <DefaultHeader @toggle-mobile-menu="handleMobileMenuToggle" class="flex-none"></DefaultHeader>
    <div class="flex flex-row flex-1 min-h-0 overflow-hidden">
      <DefaultSidebar v-if="!usesDomainShell" ref="sidebarRef"></DefaultSidebar>
      <!-- Sidebar is fixed-positioned; ml-[60px] keeps content clear of it on desktop -->
      <div class="flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden" :class="!usesDomainShell ? 'md:ml-[60px]' : ''">
        <DomainShell v-if="usesDomainShell">
          <DefaultTitle
            :dataID="dataID"
            :title="title"
            @update:deviceDetails="emit('update:deviceDetails', $event)"
            @update:ready="pageLoading = false"
            class="flex-none"
          ></DefaultTitle>

          <main class="flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden px-3 pb-3">
            <div v-if="pageLoading" class="rounded-mc-md border border-mc-steel shadow-mc-sm bg-mesh-surface-card text-mesh-text-primary flex items-center justify-center flex-1">
              <LoadingAnimation3 size="100px"></LoadingAnimation3>
            </div>
            <div v-else class="rounded-mc-md border border-mc-steel shadow-mc-sm bg-mesh-surface-card text-mesh-text-primary flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden">
              <slot />
            </div>
          </main>
        </DomainShell>

        <template v-else>
          <DefaultTitle
            :dataID="dataID"
            :title="title"
            @update:deviceDetails="emit('update:deviceDetails', $event)"
            @update:ready="pageLoading = false"
            class="flex-none"
          ></DefaultTitle>

          <main class="flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden px-3 pb-3">
            <div v-if="pageLoading" class="rounded-mc-md border border-mc-steel shadow-mc-sm bg-mesh-surface-card text-mesh-text-primary flex items-center justify-center flex-1">
              <LoadingAnimation3 size="100px"></LoadingAnimation3>
            </div>
            <div v-else class="rounded-mc-md border border-mc-steel shadow-mc-sm bg-mesh-surface-card text-mesh-text-primary flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden">
              <slot />
            </div>
          </main>
        </template>
      </div>
    </div>
    <BugReportFAB />
    <BugReportModal />
  </div>
</template>